<div class="confirm-dialog">
  <div class="dialog-header">
    <mat-icon class="warning-icon">warning</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
    @if (data.usedByComponentTypes && data.usedByComponentTypes.length > 0) {
    <div class="component-type-warning">
      <p class="warning-label">This geofence is used as a service location by:</p>
      <ul class="component-type-list">
        @for (name of data.usedByComponentTypes; track name) {
        <li>{{ name }}</li>
        }
      </ul>
      <p class="warning-note">It will be removed from all these component types before deletion.</p>
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-button">
      {{ data.cancelText }}
    </button>
    <button mat-raised-button color="warn" (click)="onConfirm()" class="delete-button">
      <mat-icon>delete</mat-icon>
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
